/**
 * 二次授权成功的弹窗
 * */
import React, { PureComponent } from 'react';
import { Modal } from 'antd';
import './SecondaryAuthSuccess.scss';
import Utils from '../../../script/util';
import {
  _change_sy_secondary_auth_success,
  _change_sy_user_login_info,
  _clear_user_info,
  _is_new_process,
  _show_login_modal,
} from '../../../store/Action';
import Util from '../../../script/util';

export default class SecondaryAuthSuccess extends PureComponent {
  // 关闭弹窗
  hideModal = () => {
    _change_sy_secondary_auth_success(false);
  };

  // 重新登录
  handleRestart = () => {
    this.hideModal();
    _clear_user_info(false);
    _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
    _show_login_modal();
  };

  // 打开申诉页面
  handleAccountError = () => {
    this.hideModal();
    this.props.openAppealH5Model('/account-appeal/index.html');
  };

  // 进入
  handleOk = () => {
    this.hideModal();
    _is_new_process();
  };

  render() {
    const { rootConfig, sySecondaryAuthSuccess, syUserLoginInfo, userInfo } =
      this.props.base;
    return (
      <Modal
        open={sySecondaryAuthSuccess}
        title="身份验证"
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="500px"
        onCancel={this.hideModal}
      >
        {sySecondaryAuthSuccess && syUserLoginInfo && userInfo ? (
          <div className="second-auth-success-result">
            <div className="icon-success" />
            <p className="auth-success-title">身份验证通过</p>
            <p className="auth-success-desc">
              已经通过验证，您的账号已经可以在本设备正常登录
            </p>

            <div className="card-box user-data">
              <div className="user-avatar">
                <img
                  src={Util.transImgUrlToGame(userInfo.avatar)}
                  alt={userInfo.nickname}
                />
              </div>
              <div className="user-info">
                <p className="user-nick">{userInfo.nickname}</p>
                <p className="user-id">ID {userInfo.uid}</p>
              </div>
              <div className="user-from">
                <p
                  className={`user-register ${userInfo.register === 1 ? 'wx' : 'qq'}`}
                >
                  <span className="icon-type" />{' '}
                  {userInfo.register === 1 ? '微信' : 'QQ'}登录
                </p>
                <p className="user-time">
                  {Utils.dateFormat(userInfo.registerTime, 'YYYY-MM-DD')}
                </p>
              </div>
            </div>

            <div className="card-box">
              <div className="label-name">
                {userInfo.register === 1 ? '微信' : 'QQ'}账号
              </div>
              <div className="label-text">
                <div className="avatar">
                  <img
                    src={Util.transImgUrlToGame(syUserLoginInfo.avatar)}
                    alt={syUserLoginInfo.nickName}
                  />
                </div>
                <span>{syUserLoginInfo.nickName}</span>
              </div>
            </div>
            <div className="card-box">
              <div className="label-name">手机绑定</div>
              <div className="label-text">
                <span>
                  {rootConfig.lang !== 'zh_CN' && userInfo.bindAreaCode
                    ? userInfo.bindAreaCode
                    : ''}{' '}
                  {Utils.getPrivatePhone(
                    userInfo.bindPhone,
                    userInfo.bindAreaCode || '86'
                  )}
                </span>
              </div>
            </div>

            <div className="btn-wrap">
              <button
                className="daidai-btn-primary again"
                onClick={this.handleAccountError}
              >
                不是我的账号，账号找回申诉
              </button>
              <button
                className="daidai-btn-primary restart"
                onClick={this.handleOk}
              >
                是我的账号，立即进入
              </button>
            </div>

            <p className="bottom-tip">
              切换登录方式？ <span onClick={this.handleRestart}>重新登录</span>
            </p>
          </div>
        ) : null}
      </Modal>
    );
  }
}
